<template>
	<div class="mobile-page-container mobile-padding flex-centerize flex-column">
		<div class="mobile-title mb-3">Open in your device's native browser to continue.</div>
		<div class="gif-container">
			<img src="/assets/gif/open-in-browser.gif" class="width-100 height-100" />
		</div>
	</div>
</template>

<script>
import BrowserService from '@/utils/BrowserService';
export default {
	name: 'FacebookWebviewNotSupported',
	mounted() {
		// Redirect to signup page if user is in Facebook app
		if (!BrowserService.isFacebookApp()) {
			this.$router.push({ name: 'Signup' });
		}
	},
};
</script>

<style scoped lang="scss">
.mobile-page-container {
	width: 100vw;
	height: calc(100vh - calc(100vh - 100%)); // this is hack for 100vh in mobile
	background: var(--setup-node-container-background);
}
.page-description {
	font-size: 16px;
	margin-top: 40px;
	text-align: center;
}
.mobile-title {
	font-size: 26px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.mobile-description {
	font-size: 16px;
	font-weight: bold;
	text-align: center;
	color: var(--primary-font-color);
}
.mobile-padding {
	padding: 0px 70px;
}
.gif-container {
}
</style>
